<template>
  <section class="contact-information-block" :id="anchorId">
    <div class="container">
      <h3 v-if="data.content.section_title">{{ data.content.section_title }}</h3>

      <div class="contacts-list">
        <div
          v-for="(contact, index) in data.content.contacts"
          :key="index"
          class="contact"
        >
          <p class="name">{{ contact.name }}</p>
          <p class="title">{{ contact.title }}</p>
          <a :href="`mailto:${contact.email}`" class="email">{{ contact.email }}</a>
          <p class="phone">{{ contact.phone }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useAnchorId } from '@/composables/useAnchorId';

const props = defineProps({
  data: {
    type: Object,
    required: true
  }
});

const anchorId = useAnchorId(toRef(props, 'data'));
</script>

<style lang="scss" scoped>
.contact-information-block {
  max-width: var(--main-width);
  margin-inline: var(--main-margin);
  overflow-x: hidden;
  border-radius: 4.25rem;
  background: var(--orange);
  padding: 3rem 2rem 5rem;
  color: var(--mahogany);
  margin-bottom: 5rem;
}

h3 {
  font-size: var(--text-m);
  letter-spacing: var(--tracking-tight);
  margin-bottom: 12rem;
  margin-inline: var(--inline-margin);
}

.contacts-list {
  display: flex;
  flex-wrap: wrap;
  gap: 3rem;
}

.contacts-list > * {
  flex: 1 1 250px;
  min-width: 0;
}

@media (max-width: 767px) {
  .contacts-list > * {
    flex-basis: 100%;
  }
}

.contact {
  font-size: var(--text-lg);
  font-weight: var(--font-semibold);
  line-height: inherit;

  p {
    margin-bottom: 0;
  }

  .title {
    opacity: 0.95;
  }

  .email {
    display: block;
    font-size: var(--text-lg);
    font-weight: var(--font-semibold);
    color: var(--mahogany);
    text-decoration: none;
    opacity: 0.95;

    &:hover {
      text-decoration: underline;
    }
  }

  .phone {
    margin-bottom: 0;
    opacity: 0.95;
  }
}
</style>
